module.exports = __webpack_public_path__ + "img/ford-ScheduleService.185cd715.png";